import { render, staticRenderFns } from "./kpsrGuideword.vue?vue&type=template&id=5326b9b9"
import script from "./kpsrGuideword.vue?vue&type=script&lang=js"
export * from "./kpsrGuideword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5326b9b9')) {
      api.createRecord('5326b9b9', component.options)
    } else {
      api.reload('5326b9b9', component.options)
    }
    module.hot.accept("./kpsrGuideword.vue?vue&type=template&id=5326b9b9", function () {
      api.rerender('5326b9b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/base/kpsrGuideword.vue"
export default component.exports